export default __webpack_public_path__ + "static/media/settings_mobile.bb8bc891.svg";